import { Hero } from '../components/sections/Hero/Hero';
import { Clients } from '../components/sections/Clients/Clients';
import { About } from '../components/sections/About/About';
import { Services } from '../components/sections/Services/Services';
import { Categories } from '../components/sections/Categories/Categories';
import { Showcase } from '../components/sections/Showcase/Showcase';
import { Stats } from '../components/sections/Stats/Stats';
import { Testimonials } from '../components/sections/Testimonials/Testimonials';
import { CTA } from '../components/sections/CTA/CTA';

export function Home() {
  return (
    <>
      <Hero />
      <Clients />
      <About />
      <Services />
      <Categories />
      <Showcase />
      <Stats />
      <Testimonials />
      <CTA />
    </>
  );
}
